<template>
  <v-container
    class="pa-1 section-container fill-height"
    fluid
    style="display: flex; justify-content: center"
  >
    <v-col
      cols="12"
      class="notification-container"
      :class="{ unread: !notification.read }"
      @click="showNotification"
    >
      <v-card
        flat
        class="notification pa-2"
        :class="{ unread: !notification.read }"
      >
        <v-row style="margin: 0">
          <v-col cols="6" sm="6" style="padding: 0">
            <div :style="notificationTypeStyle">
              {{ notification.notification_type.label }}
            </div>
          </v-col>
          <v-col align="center" class="margin:0 notification-body" cols="6"
            >{{ notification.title }}
          </v-col>

          <v-col
            v-if="$store.state.app_display_scheme"
            cols="12"
            style="
              padding: 0;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            <div
              style="
                width: 100%;
                padding-left: 20px;
                display: flex;
                align-items: center;
                justify-content: space-evenly;
              "
            >
              <v-icon v-if="notification.request.is_urgency" color="error">
                error
              </v-icon>
              <v-img
                v-if="notification.request.scheme == 'asistencia'"
                contain
                src="../icons/asistencia.png"
                height="20"
                width="20"
              ></v-img>
              <v-img
                v-if="notification.request.scheme == 'cliente-final'"
                contain
                src="../icons/clientefinal.png"
                height="20"
                width="20"
              ></v-img>
              <v-img
                v-if="notification.request.scheme == 'corpo'"
                contain
                src="../icons/corporativo.png"
                height="20"
                width="20"
              ></v-img>
              <v-img
                v-if="notification.request.scheme == 'fletes'"
                contain
                src="../icons/fletes.png"
                height="20"
                width="20"
              ></v-img>
              <v-img
                v-if="notification.request.scheme == 'inmobiliaria'"
                contain
                src="../icons/inmobiliaria.png"
                height="20"
                width="20"
              ></v-img>
              <v-col
                v-if="
                  notification &&
                  notification.request &&
                  notification.request.service
                "
                style="font-weight: bold; text-transform: capitalize"
                class="margin:0 body-item"
                cols="12"
                >{{ notification.request.service.name }}
              </v-col>
            </div>
          </v-col>
        </v-row>

        <v-row
          align="center"
          style="font-weight: bold; text-transform: capitalize"
          class="margin:0 notification-body"
        >
        </v-row>

        <v-row align="center" class="notification-body">
          <v-col
            v-if="notification && notification.request"
            class="body-item"
            cols="12"
            >Dirección: {{ notification.request.full_address }}</v-col
          >
        </v-row>

        <v-row align="center" class="notification-body">
          <v-col
            v-if="notification.request && notification.request.availability"
            class="body-item"
            cols="12"
            >Fecha y hora:
            {{
              notification.request.availability[0].date_from
                | formatDateTimeShort
            }}</v-col
          >
        </v-row>
      </v-card>
    </v-col>
  </v-container>
</template>
<script>
export default {
  name: "NotificationItem",

  props: {
    notification: Object,
  },

  computed: {
    notificationTypeStyle: function () {
      const style = `
        background-color:${this.notification.notification_type.backgroundColor};
        color:${this.notification.notification_type.color};
        padding: 6px;
        font-size: 12px;
        display: flex;
        justify-content: center;
      `;
      return style;
    },
  },

  methods: {
    showNotification(item) {
      this.$emit("show-notification", item);
    },
  },
};
</script>

<style scoped>
@media (max-width: 959px) {
  .section-container {
    padding: 12px 0 !important;
    background: #eeeeee;
  }
  .notification-container {
    padding: 12px 0;
    border-bottom: 1px solid lightgrey;
  }
  .notification {
    padding-bottom: 12px;
    border-radius: 0 !important;
    width: 100vw;
  }
  .notification-body {
    margin: 0 0 12px;
    padding-left: 10px;
    font-size: 16px;
  }
  .unread {
    background: #e3f2fd !important;
  }
  .notification-title {
    margin-left: 6px;
    font-weight: bold;
    font-size: 12px;
  }
  .body-item {
    padding: 0;
  }
}
</style>
